// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3hGzR","info":"Note_info__3kmsO","note":"Note_note__24to0","actions":"Note_actions__3SZ65"};